import VcsDetailsPage from "../../shared/VcsShared/components/VcsDetailsPage";

const AzureDevOpsDetailsPage = VcsDetailsPage;

export default AzureDevOpsDetailsPage;
